import { useState, useCallback } from 'react'
import { useToast } from './useToast'

export const useCampaignModal = (condition = true, t) => {
  const [isCreateCampaignOpen, setIsCreateCampaignOpen] = useState(false)

  const { showError } = useToast()

  const openCreateCampaignModal = useCallback(() => {
    if (condition) {
      setIsCreateCampaignOpen(true)
    } else {
      showError(t('mailTemplate.campaigns.settingsMissingErr'))
    }
  }, [condition, showError, t])

  const closeCreateCampaignModal = useCallback(() => {
    setIsCreateCampaignOpen(false)
  }, [])

  return {
    isCreateCampaignOpen,
    openCreateCampaignModal,
    closeCreateCampaignModal
  }
}
